module.exports = __webpack_public_path__ + "static/media/saleIcon.4ae4bc72.svg";